import React from 'react'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { BANKING_BOTTOM_CONTENT, DATA_COURSE_PAGE_1, DATA_DETAILS_PAGE_1, DATA_HERO_PAGE_1 } from '../../../utils/constants'
import { DATA_ACCORDIAN_1 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const DataSciencePage_1 = () => {
  return (
    <div className='outlet-render'>
      <CourseAsideHero {...DATA_HERO_PAGE_1}/>
      <CoursesAside {...DATA_COURSE_PAGE_1}/>
      <CourseCard {...DATA_DETAILS_PAGE_1}/>
      <Accordian {...DATA_ACCORDIAN_1}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DataSciencePage_1